import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=77cc291c&"
import script from "./inquiry.vue?vue&type=script&lang=js&"
export * from "./inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports